import { render, staticRenderFns } from "./TaxOutputTable.vue?vue&type=template&id=5bb80009&scoped=true"
import script from "./TaxOutputTable.vue?vue&type=script&lang=js"
export * from "./TaxOutputTable.vue?vue&type=script&lang=js"
import style0 from "./TaxOutputTable.vue?vue&type=style&index=0&id=5bb80009&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb80009",
  null
  
)

export default component.exports